<template lang="pug">
    .selector

        Corners

        p.selector__lead(
            v-html='lead'
            )
        
        .selector__select-block
            
            .block-selector

                .block-selector__arrow.block-selector__arrow--left(
                    @click='changeArticle("prev")'
                    )
                    svg
                        use(
                            xlink:href='#downarrow'
                        )

                .block-selector__wrapper(
                    :class='`position-${articleActive}`'
                    )

                    .block-selector__item(
                        v-for='(article, name) in articles',
                        :key='name',
                        :class='`theme-${article.color}`',
                        @click='$emit("update:articleActive", name)'
                        )
                        svg.block-selector__image
                            use(
                                :xlink:href='`#${name}svg`'
                            )
                
                .block-selector__arrow.block-selector__arrow--right(
                    @click='changeArticle("next")'
                    )
                    svg
                        use(
                            xlink:href='#downarrow'
                        )
            
            .block-selector-blocks

                .block-selector-blocks__item(
                    v-for='(article, name) in articles',
                    :key='name',
                    :class='[`theme-${article.color}`, {active: articleActive === name}]',
                    @click='$emit("update:articleActive", name)'
                    )
                    .block-selector-blocks__item-button

            .block-selector-texts

                .block-selector-texts__item-dummy
                    p(v-html='articles["firststeps"].lead')

                .block-selector-texts__item(
                    v-for='(article, name) in articles',
                    :key='name',
                    :class='[`theme-${article.color}`, {active: articleActive === name}]',
                    @click='$emit("update:articleActive", name)'
                    )
                    p(v-html='article.lead')
        
        Follow(
            :isInnerPage='true',
            v-on:clicknexttrigger='$emit("scrollToArticles")'
            )
            
        

</template>

<script>
const Follow = () => import('@/components/Follow.vue');
const Corners = () => import('@/components/Corners.vue');

export default {
    name: 'Selector',

    components: {
        Follow,
        Corners
    },

    props: {
        articles: Object,
        lead: String,
        articleActive: String
    },

    methods: {
        changeArticle(direction) {
            const artNames = ['firststeps', 'growing', 'convolution'];

            const curArtIndex = artNames.indexOf(this.articleActive);

            let art = artNames[0];

            if (direction === 'prev' && curArtIndex !== 0) {
                art = artNames[curArtIndex - 1];
            } else if (direction === 'prev' && curArtIndex === 0) {
                art = artNames[artNames.length - 1];
            } else if (direction === 'next' && curArtIndex < artNames.length - 1) {
                art = artNames[curArtIndex + 1];
            } else if (direction === 'next' && curArtIndex === artNames.length - 1) {
                artNames[0];
            }

            this.$emit('update:articleActive', art);
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../assets/css/vars.scss';

.theme-orange {
    --theme: var(--color-orange);
}

.theme-lemon {
    --theme: var(--color-lemon);
}

.theme-green {
    --theme: var(--color-green);
}

.selector {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
    min-height: 100vh;
    min-height: calc(var(--vh) * 100);
    --theme: var(--color-green);

    @media (--viewport-tablet) {
        padding: 0 20px;
    }

    @media (--viewport-tablet) {
        padding-top: calc(var(--block-height) * 2);
    }

    &__lead {
        max-width: 650px;
        margin-top: 40px;
    }

    &__select-block {
        max-width: 650px;
        margin: 40px 0;

        @media (--viewport-tablet) {
            width: 100%;
        }
    }
}

.block-selector {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    perspective: 1000px;

    &__arrow {
        position: relative;
        width: 42px;
        height: 42px;
        cursor: pointer;
        padding: 10px;
        box-sizing: border-box;

        &--left {
            @media (--viewport-tablet) {
                padding-left: 0;
            }

            svg {
                transform: rotate(90deg);
            }
        }

        &--right {
            @media (--viewport-tablet) {
                padding-right: 0;
            }

            svg {
                transform: rotate(-90deg);
            }
        }

        svg {
            width: 22px;
            height: 22px;
            fill: #9a9b9f;
        }
    }

    &__wrapper {
        position: relative;
        width: 394px;
        height: 236px;
        transition: transform 0.6s ease-in-out;
        transform-style: preserve-3d;
        transform: rotateY(0deg);
        pointer-events: none;

        @media (--viewport-tablet) {
            width: calc(100vw - 100px);
            height: calc(100vw - 100px * (394 / 236));
        }

        &.position-growing {
            // transform: rotate3d(0, 1, 0, 90deg);
            transform: rotateY(120deg);
        }

        &.position-convolution {
            // transform: rotate3d(0, 1, 0, -90deg);
            transform: rotateY(-120deg);
        }
    }

    &__item {
        position: absolute;
        top: 0;
        left: 0;
        width: 394px;
        height: 236px;
        backface-visibility: hidden;

        @media (--viewport-tablet) {
            width: calc(100vw - 100px);
            height: calc(100vw - 100px * (394 / 236));
            pointer-events: none;
        }

        svg {
            width: 394px;
            height: 236px;

            @media (--viewport-tablet) {
                width: calc(100vw - 100px);
                height: calc(100vw - 100px * (394 / 236));
            }
        }

        &:nth-child(1) {
            transform: translateZ(50px);

            @media (--viewport-tablet) {
                margin-left: -4vw;
            }
        }

        &:nth-child(2) {
            left: 50%;
            margin-left: -197px;
            transform: rotateY(-120deg) translate3d(0, 0, 197px);

            @media (--viewport-tablet) {
                margin-left: -33vw;
            }
        }

        &:nth-child(3) {
            left: 50%;
            margin-left: -197px;
            transform: rotateY(120deg) translate3d(0, 0, 197px);

            @media (--viewport-tablet) {
                margin-left: -33vw;
            }
        }
    }
}

.block-selector-blocks {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 20px 0 0 0;

    &__item {
        padding: 20px 20px;
        margin: 0 10px;
        cursor: pointer;
        pointer-events: all;

        &-button {
            width: calc(var(--block-height) + 7px);
            height: var(--block-height);
            border: 3px solid var(--theme);
            transition: background 0.6s ease;
        }

        &.active {
            .block-selector-blocks__item-button {
                background-color: var(--theme);
            }
        }
    }
}

.block-selector-texts {
    position: relative;
    padding: 20px 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    &__item {
        display: inline-block;
        padding: 20px;
        text-align: center;
        opacity: 0;
        transform: translateY(20px);
        transition: opacity 0.6s ease, transform 0.6s ease-out;
        position: absolute;

        @media (--viewport-tablet) {
            font-size: 1.31rem;
        }

        &.active {
            transition: opacity 0.6s ease 0.7s, transform 0.6s ease-out 0.7s;
            opacity: 1;
            transform: translateY(0px);
            padding: 20px 0;
        }

        &-dummy {
            max-width: calc(var(--content-width) / 3);
            opacity: 0;
            @media (--viewport-tablet) {
                font-size: 1.31rem;
            }
        }
    }
}
</style>
